module.exports = __webpack_public_path__ + "static/img/logo.e9d277cf.png";